import varAxios from "../../Comman/axios";
import { useHistory } from 'react-router-dom';
import decode from 'jwt-decode';
import { SentOneTimePassword,RequestForgotPassword,forgotPasswordUrl,GetCompanyBrandingList } from "../../Comman/apiEndPoints"

export const RESET_USER_PASSWORD_REQUEST = "(login) RESET USER PASSWORD REQUEST";
export const RESET_USER_PASSWORD_SUCCESS = "(login) RESET USER PASSWORD SUCCESS";
export const RESET_USER_PASSWORD_ERROR = "(login) RESET USER PASSWORD ERROR";

export const FETCH_USER_PASSWORD_REQUEST = "(login) FETCH USER PASSWORD REQUEST";
export const GET_COMPANY_REQUEST = "GET_COMPANY_REQUEST";
export const APPLICATION_REQUEST="APPLICATION_REQUEST";
export const ADD_COMPANY_REQUEST= "ADD_COMPANY_REQUEST";

export const RESET_USER_PASSWORD_REQUEST1 = "RESET USER PASSWORD REQUEST1";
export const RESET_USER_PASSWORD_SUCCESS1 = "RESET USER PASSWORD SUCCESS1";
export const RESET_USER_PASSWORD_ERROR1 = "RESET USER PASSWORD ERROR1";

export const FETCH_USER_PASSWORD_REQUEST1 = "FETCH USER PASSWORD REQUEST1";

export const RESET_USER_PASSWORD_REQUEST2 = "RESET USER PASSWORD REQUEST2";
export const RESET_USER_PASSWORD_SUCCESS2 = "RESET USER PASSWORD SUCCESS2";
export const RESET_USER_PASSWORD_ERROR2 = "RESET USER PASSWORD ERROR2";

export const FETCH_USER_PASSWORD_REQUEST2 = "FETCH USER PASSWORD REQUEST2";
 
export function getCompanyBrandingList() {
    return (dispatch) => {
      dispatch(ApplicationRequest(true)); 

        return varAxios.get(GetCompanyBrandingList)
            .then((response) => {
                debugger
              dispatch(
                 fetchGetCompanyBrandingListSuccessData(
                false,
            response.data.errorCode,
               response.data.statusCode,
                response.data.brandlist
            )
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
 export function ApplicationRequest(isLoading){
    return {
      type : APPLICATION_REQUEST,
      isLoading
    }
  }
export function fetchGetCompanyBrandingListSuccessData(isLoading,errorCode,statusCode,brandList) {
   
    return {
        type : ADD_COMPANY_REQUEST,
       isLoading,
      errorCode,
      statusCode,
      brandList
    }
}
export function ResetUserPasswordSuccess(isLoading,errorMessage,statusCode ) {
    return {
        type: RESET_USER_PASSWORD_SUCCESS,
        isLoading,
        errorMessage,
        statusCode
    }
}
export function FetchUserPasswordRequest() {
    return {
        type: FETCH_USER_PASSWORD_REQUEST,
        
    }
}
export function ResetUserPasswordRequest( ) {
    let isLoading=true;
    return {
        type: RESET_USER_PASSWORD_REQUEST,
        isLoading,
       
    }
}
export function ResetUserPasswordError(isLoading,statusCode, errorCode, errorMessage ) {
    return {
        type: RESET_USER_PASSWORD_ERROR,
        isLoading,
        statusCode,
        errorCode,
        errorMessage
    }
}

export function ResetUserPassword(Email,dispatch) {
    let data = {
        EmailId: Email,
        
    }
    dispatch(ResetUserPasswordRequest(true));
    return (dispatch) => {
       
        return varAxios.post(forgotPasswordUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    ResetUserPasswordSuccess(
                        false,
                        response.data.errorMessage,
                        response.data.statusCode
                    ));
                
            })
            .catch((error) => {
                
                dispatch(
                    ResetUserPasswordError(
                        false,
                        error.response.data.statusCode,
                       error.response.data.errorCode, 
                        error.response.data.errorMessage,
                    ));
            })

    }
}

export function ResetUserPasswordSuccess1(isLoading,requestForgotPasswordDetail,errorMessage,statusCode ) {
    return {
        type: RESET_USER_PASSWORD_SUCCESS1,
        requestForgotPasswordDetail,
        isLoading,
        errorMessage,
        statusCode
    }
}
export function FetchUserPasswordRequest1() {
    return {
        type: FETCH_USER_PASSWORD_REQUEST1,
        
    }
}
export function ResetUserPasswordRequest1( ) {
    let isLoading=true;
    return {
        type: RESET_USER_PASSWORD_REQUEST1,
        isLoading,
       
    }
}
export function ResetUserPasswordError1(isLoading,statusCode, errorCode, errorMessage ) {
    return {
        type: RESET_USER_PASSWORD_ERROR1,
        isLoading,
        statusCode,
        errorCode,
        errorMessage
    }
}

export function ResetUserPassword1(Email,dispatch) {
    let data = {
        EmailId: Email,
        
    }
    dispatch(ResetUserPasswordRequest1(true));
    return (dispatch) => {
       
        return varAxios.post(RequestForgotPassword, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    ResetUserPasswordSuccess1(
                        false,
                        response.data.requestForgotPasswordDetail,
                        response.data.errorMessage,
                        response.data.statusCode
                    ));
                
            })
            .catch((error) => {
                
                dispatch(
                    ResetUserPasswordError1(
                        false,
                        error.response.data.statusCode,
                       error.response.data.errorCode, 
                        error.response.data.errorMessage,
                    ));
            })

    }
}





export function ResetUserPasswordSuccess2(isLoading,errorMessage,statusCode ) {

    return {
        type: RESET_USER_PASSWORD_SUCCESS2,
        isLoading,
        errorMessage,
        statusCode
    }
}
export function FetchUserPasswordRequest2() {
    return {
        type: FETCH_USER_PASSWORD_REQUEST2,
        
    }
}
export function ResetUserPasswordRequest2( ) {
    let isLoading=true;
    return {
        type: RESET_USER_PASSWORD_REQUEST2,
        isLoading,
       
    }
}
export function ResetUserPasswordError2(isLoading,statusCode, errorCode, errorMessage ) {
    return {
        type: RESET_USER_PASSWORD_ERROR2,
        isLoading,
        statusCode,
        errorCode,
        errorMessage
    }
}

export function ResetUserPassword2(data,dispatch) {
   
    dispatch(ResetUserPasswordRequest2(true));
    return (dispatch) => {
       
        return varAxios.post(SentOneTimePassword, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    ResetUserPasswordSuccess2(
                        false,
                       
                        response.data.Message,
                        response.data.statusCode
                    ));
                  
                
            })
           /*  .catch((error) => {
                
                dispatch(
                    ResetUserPasswordError2(
                        false,
                        error.response.data.statusCode,
                       error.response.data.errorCode, 
                        error.response.data.Message,
                    ));
            }) */

    }
}



